import React from 'react';
import { Router } from '@reach/router';

import SignIn from '../../features/auth/SignIn';
import SignUpMember from '../../features/auth/SignUpMember';
import PasswordResetPage from '../../features/auth/PasswordResetPage';
import SignUpReferrerPage, { SignUpReferrerPagePath } from '../../features/auth/SignUpReferrerPage';

const SignedOutRouter = () => {
    return (
        <Router>
            <SignIn default />
            <SignIn path="/" />
            <SignIn path="/signin" />
            
            <SignUpMember path="/signup/member" />
            <SignUpReferrerPage path={SignUpReferrerPagePath} />
            
            <PasswordResetPage path="/auth/reset" />
            <PasswordResetPage path="/auth/reset/:email" />
        </Router>
    );
}

export default SignedOutRouter;